<div *ngIf="!isProd" class="dev-banner">
  MODE DÉVELOPPEMENT - API: {{ apiUrl }} - {{ version }}
</div>
<router-outlet fxFlexFill></router-outlet>
